if (!Math.sign) Math.sign = function(x) { return ((x > 0) - (x < 0)) || +x; };
document.addEventListener('DOMContentLoaded', function () {

    let touch = null;
    // for the vertical slide
    touch = window.innerWidth <= 1024;

    let mySwiper = new Swiper('main > .swiper-container', {
        // Optional parameters
        direction: 'vertical',
        loop: false,
        mousewheel: {
            releaseOnEdges: true
        },
        speed: 500,
        simulateTouch: touch,
    });

    const MENU = new Menu(mySwiper, 'main-page-site');
    new TooltipManagement();

    if (document.querySelector("body").classList.contains("main-page-site")) {

        if (window.location.hash !== '') {
            MENU.goToSection(window.location.hash.split('#')[1]);
        }

        new ManageVerticalSlide();
        new ManageChoiceCategorySectionButtons();
        new ManageHorizontalSlide(mySwiper);
        new chooseMyCable(mySwiper);
        new OverlayVideo();
        new OverlayImage();
        new DdpBtn(mySwiper);
    }

    if (document.querySelector("body").classList.contains("contact-page")) {
        new ContactFormManagement();
        new CustomSelect();
    }

    if (document.querySelector("body").classList.contains("partners-page")) {
        new ManageMenu();
    }

    var animationData = {
        "v": "5.6.1",
        "fr": 25,
        "ip": 0,
        "op": 125,
        "w": 685,
        "h": 1080,
        "nm": "intro",
        "ddd": 0,
        "assets": [{"id": "image_0", "w": 35, "h": 46, "u": "theme/sycabel/asset/img/Animation/", "p": "img_0.png", "e": 0}],
        "layers": [{
            "ddd": 0, "ind": 1, "ty": 2, "nm": "B4_START", "refId": "image_0", "sr": 1, "ks": {
                "o": {"a": 1, "k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 74.852, "s": [100]}, {"t": 78.4150390625, "s": [0]}], "ix": 11},
                "r": {"a": 0, "k": -87, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.167, "y": 0.167}, "t": 31.188, "s": [646.875, -40.498, 0], "to": [0, 0, 0], "ti": [0, 0, 0]}, {
                        "i": {"x": 0.562, "y": 0.562},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 32.971,
                        "s": [646.875, 1.502, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"i": {"x": 0.653, "y": 0.653}, "o": {"x": 0.313, "y": 0.313}, "t": 43.602, "s": [646.875, 600.07, 0], "to": [0, 167.86, 0], "ti": [167.86, 0, 0]}, {
                        "i": {
                            "x": 0.672,
                            "y": 0.672
                        }, "o": {"x": 0.332, "y": 0.332}, "t": 52.082, "s": [342.938, 904.007, 0], "to": [-167.859, 0, 0], "ti": [0, 167.86, 0]
                    }, {"i": {"x": 0.694, "y": 0.694}, "o": {"x": 0.351, "y": 0.351}, "t": 60.563, "s": [39.002, 600.07, 0], "to": [0, -167.859, 0], "ti": [-167.859, 0, 0]}, {
                        "i": {
                            "x": 0.768,
                            "y": 0.768
                        }, "o": {"x": 0.401, "y": 0.401}, "t": 69.045, "s": [342.938, 296.134, 0], "to": [145.872, 0, 0], "ti": [-29.425, -137.081, 0]
                    }, {"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.4, "y": 0.4}, "t": 76.379, "s": [640.105, 535.979, 0], "to": [0, 0, 0], "ti": [0, -34.131, 0]}, {
                        "t": 77.525390625,
                        "s": [646.875, 600.07, 0]
                    }],
                    "ix": 2
                },
                "a": {"a": 0, "k": [15.998, 3.521, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            }, "ao": 1, "ip": 26, "op": 160, "st": 35, "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "B4",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [343.58, 453.753, 0], "ix": 2},
                "a": {"a": 0, "k": [350.439, 497.755, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [167.86, 0], [0, 167.86], [-167.859, 0], [-29.425, -137.081], [0, -34.131]],
                            "o": [[0, 0], [0, 167.86], [-167.859, 0], [0, -167.859], [145.872, 0], [0, 0], [0, 0]],
                            "v": [[303.937, -451.253], [303.937, 147.315], [-0.001, 451.253], [-303.937, 147.315], [-0.001, -156.62], [297.167, 83.224], [303.937, 147.315]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {"a": 0, "k": [0.322000002394, 0.532999973671, 0.929000016755, 1], "ix": 3},
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 18.601, "ix": 5},
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [350.439, 497.755], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "tm",
                "s": {"a": 1, "k": [{"i": {"x": [0.96], "y": [1]}, "o": {"x": [1], "y": [0]}, "t": 65.05, "s": [0]}, {"t": 85, "s": [24]}], "ix": 1},
                "e": {"a": 1, "k": [{"i": {"x": [0.833], "y": [0.833]}, "o": {"x": [0.167], "y": [0.167]}, "t": 32.971, "s": [0]}, {"t": 77.525390625, "s": [100]}], "ix": 2},
                "o": {"a": 0, "k": 0, "ix": 3},
                "m": 1,
                "ix": 2,
                "nm": "Trim Paths 1",
                "mn": "ADBE Vector Filter - Trim",
                "hd": false
            }],
            "ip": 26,
            "op": 160,
            "st": 35,
            "bm": 0
        }, {
            "ddd": 0, "ind": 3, "ty": 2, "nm": "B3_START", "refId": "image_0", "sr": 1, "ks": {
                "o": {"a": 1, "k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 70.396, "s": [100]}, {"t": 73.9599609375, "s": [0]}], "ix": 11},
                "r": {"a": 0, "k": -89, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.167, "y": 0.167}, "t": 26.733, "s": [631.906, -36.498, 0], "to": [0, 0, 0], "ti": [0, 0, 0]}, {
                        "i": {"x": 0.562, "y": 0.562},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 28.516,
                        "s": [631.906, -0.498, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"i": {"x": 0.654, "y": 0.654}, "o": {"x": 0.314, "y": 0.314}, "t": 39.574, "s": [631.906, 598.993, 0], "to": [0, 159.584, 0], "ti": [159.584, 0, 0]}, {
                        "i": {
                            "x": 0.672,
                            "y": 0.672
                        }, "o": {"x": 0.333, "y": 0.333}, "t": 47.948, "s": [342.954, 887.946, 0], "to": [-159.584, 0, 0], "ti": [0, 159.584, 0]
                    }, {"i": {"x": 0.695, "y": 0.695}, "o": {"x": 0.352, "y": 0.352}, "t": 56.322, "s": [54.002, 598.993, 0], "to": [0, -159.583, 0], "ti": [-159.584, 0, 0]}, {
                        "i": {
                            "x": 0.768,
                            "y": 0.768
                        }, "o": {"x": 0.401, "y": 0.401}, "t": 64.696, "s": [342.954, 310.042, 0], "to": [138.68, 0, 0], "ti": [-27.974, -130.322, 0]
                    }, {"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.4, "y": 0.4}, "t": 71.938, "s": [625.47, 538.06, 0], "to": [0, 0, 0], "ti": [0, -32.449, 0]}, {
                        "t": 73.0693359375,
                        "s": [631.906, 598.993, 0]
                    }],
                    "ix": 2
                },
                "a": {"a": 0, "k": [15.998, 3.896, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            }, "ao": 1, "ip": 21, "op": 155, "st": 30, "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "B3",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [343.58, 443.722, 0], "ix": 2},
                "a": {"a": 0, "k": [335.454, 490.724, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [159.584, 0], [0, 159.584], [-159.584, 0], [-27.974, -130.322], [0, -32.449]],
                            "o": [[0, 0], [0, 159.584], [-159.584, 0], [0, -159.583], [138.68, 0], [0, 0], [0, 0]],
                            "v": [[288.952, -444.222], [288.952, 155.269], [0, 444.222], [-288.952, 155.269], [0, -133.682], [282.516, 94.336], [288.952, 155.269]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {"a": 0, "k": [0, 0.46699999641, 0.760999971278, 1], "ix": 3},
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 18.601, "ix": 5},
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [335.454, 490.724], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "tm",
                "s": {"a": 1, "k": [{"i": {"x": [0.761], "y": [1]}, "o": {"x": [0.548], "y": [0]}, "t": 45.445, "s": [0]}, {"t": 79.306640625, "s": [25]}], "ix": 1},
                "e": {"a": 1, "k": [{"i": {"x": [0.833], "y": [0.833]}, "o": {"x": [0.167], "y": [0.167]}, "t": 28.516, "s": [0]}, {"t": 73.0693359375, "s": [100]}], "ix": 2},
                "o": {"a": 0, "k": 0, "ix": 3},
                "m": 1,
                "ix": 2,
                "nm": "Trim Paths 1",
                "mn": "ADBE Vector Filter - Trim",
                "hd": false
            }],
            "ip": 21,
            "op": 155,
            "st": 30,
            "bm": 0
        }, {
            "ddd": 0, "ind": 5, "ty": 2, "nm": "B2_START", "refId": "image_0", "sr": 1, "ks": {
                "o": {"a": 1, "k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 67.723, "s": [100]}, {"t": 71.287109375, "s": [0]}], "ix": 11},
                "r": {"a": 0, "k": -88, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.167, "y": 0.167}, "t": 24.06, "s": [615.492, -49.498, 0], "to": [0, 0, 0], "ti": [0, 0, 0]}, {
                        "i": {"x": 0.562, "y": 0.562},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 25.842,
                        "s": [615.492, -1.498, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"i": {"x": 0.655, "y": 0.655}, "o": {"x": 0.315, "y": 0.316}, "t": 37.339, "s": [615.492, 595.704, 0], "to": [0, 150.909, 0], "ti": [150.909, 0, 0]}, {
                        "i": {
                            "x": 0.673,
                            "y": 0.673
                        }, "o": {"x": 0.333, "y": 0.333}, "t": 45.604, "s": [342.247, 868.949, 0], "to": [-150.908, 0, 0], "ti": [0, 150.909, 0]
                    }, {"i": {"x": 0.695, "y": 0.695}, "o": {"x": 0.352, "y": 0.352}, "t": 53.867, "s": [69.003, 595.704, 0], "to": [0, -150.908, 0], "ti": [-150.908, 0, 0]}, {
                        "i": {
                            "x": 0.768,
                            "y": 0.768
                        }, "o": {"x": 0.401, "y": 0.401}, "t": 62.132, "s": [342.247, 322.46, 0], "to": [131.141, 0, 0], "ti": [-26.454, -123.239, 0]
                    }, {"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.4, "y": 0.4}, "t": 69.278, "s": [609.405, 538.084, 0], "to": [0, 0, 0], "ti": [0, -30.684, 0]}, {
                        "t": 70.3955078125,
                        "s": [615.492, 595.704, 0]
                    }],
                    "ix": 2
                },
                "a": {"a": 0, "k": [16.123, 3.646, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            }, "ao": 1, "ip": 18, "op": 152, "st": 27, "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "B2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [343.58, 434.724, 0], "ix": 2},
                "a": {"a": 0, "k": [319.747, 481.726, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [150.909, 0], [0, 150.909], [-150.908, 0], [-26.454, -123.239], [0, -30.684]],
                            "o": [[0, 0], [0, 150.909], [-150.908, 0], [0, -150.908], [131.141, 0], [0, 0], [0, 0]],
                            "v": [[273.245, -435.224], [273.245, 161.979], [0, 435.224], [-273.245, 161.979], [0, -111.266], [267.158, 104.358], [273.245, 161.979]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {"a": 0, "k": [0.141000007181, 0.616000007181, 0.917999985639, 1], "ix": 3},
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 18.601, "ix": 5},
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [319.747, 481.726], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "tm",
                "s": {"a": 1, "k": [{"i": {"x": [0.885], "y": [1]}, "o": {"x": [0.567], "y": [0]}, "t": 36.535, "s": [0]}, {"t": 70.3955078125, "s": [26]}], "ix": 1},
                "e": {"a": 1, "k": [{"i": {"x": [0.833], "y": [0.833]}, "o": {"x": [0.167], "y": [0.167]}, "t": 25.842, "s": [0]}, {"t": 70.3955078125, "s": [100]}], "ix": 2},
                "o": {"a": 0, "k": 0, "ix": 3},
                "m": 1,
                "ix": 2,
                "nm": "Trim Paths 1",
                "mn": "ADBE Vector Filter - Trim",
                "hd": false
            }],
            "ip": 18,
            "op": 152,
            "st": 27,
            "bm": 0
        }, {
            "ddd": 0, "ind": 7, "ty": 2, "nm": "B1_START", "refId": "image_0", "sr": 1, "ks": {
                "o": {"a": 1, "k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 63.267, "s": [100]}, {"t": 66.83203125, "s": [0]}], "ix": 11},
                "r": {"a": 0, "k": -89, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.167, "y": 0.167}, "t": 19.604, "s": [601.484, -39.498, 0], "to": [0, 0, 0], "ti": [0, 0, 0]}, {
                        "i": {"x": 0.562, "y": 0.562},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 21.386,
                        "s": [601.484, -1.498, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"i": {"x": 0.656, "y": 0.656}, "o": {"x": 0.317, "y": 0.317}, "t": 33.403, "s": [601.484, 596.73, 0], "to": [0, 142.346, 0], "ti": [142.346, 0, 0]}, {
                        "i": {
                            "x": 0.673,
                            "y": 0.673
                        }, "o": {"x": 0.334, "y": 0.334}, "t": 41.538, "s": [343.743, 854.471, 0], "to": [-142.347, 0, 0], "ti": [0, 142.346, 0]
                    }, {"i": {"x": 0.695, "y": 0.695}, "o": {"x": 0.352, "y": 0.352}, "t": 49.672, "s": [86.002, 596.73, 0], "to": [0, -142.347, 0], "ti": [-142.347, 0, 0]}, {
                        "i": {
                            "x": 0.768,
                            "y": 0.768
                        }, "o": {"x": 0.402, "y": 0.402}, "t": 57.807, "s": [343.743, 338.988, 0], "to": [123.7, 0, 0], "ti": [-24.953, -116.246, 0]
                    }, {"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.4, "y": 0.4}, "t": 64.841, "s": [595.743, 542.378, 0], "to": [0, 0, 0], "ti": [0, -28.945, 0]}, {
                        "t": 65.9404296875,
                        "s": [601.484, 596.73, 0]
                    }],
                    "ix": 2
                },
                "a": {"a": 0, "k": [16.123, 3.896, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            }, "ao": 1, "ip": 13, "op": 147, "st": 22, "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "B1",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [343.58, 427.484, 0], "ix": 2},
                "a": {"a": 0, "k": [304.243, 474.487, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [142.346, 0], [0, 142.346], [-142.347, 0], [-24.953, -116.246], [0, -28.945]],
                            "o": [[0, 0], [0, 142.346], [-142.347, 0], [0, -142.347], [123.7, 0], [0, 0], [0, 0]],
                            "v": [[257.741, -427.984], [257.741, 170.244], [0, 427.984], [-257.741, 170.244], [0, -87.498], [252, 115.891], [257.741, 170.244]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {"a": 0, "k": [0.430999995213, 0.764999988032, 0.972999961703, 1], "ix": 3},
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 18.601, "ix": 5},
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [304.243, 474.487], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "tm",
                "s": {"a": 1, "k": [{"i": {"x": [0.859], "y": [1]}, "o": {"x": [0.643], "y": [0]}, "t": 32.079, "s": [0]}, {"t": 65.9404296875, "s": [27]}], "ix": 1},
                "e": {"a": 1, "k": [{"i": {"x": [0.833], "y": [0.833]}, "o": {"x": [0.167], "y": [0.167]}, "t": 21.386, "s": [0]}, {"t": 65.9404296875, "s": [100]}], "ix": 2},
                "o": {"a": 0, "k": 0, "ix": 3},
                "m": 1,
                "ix": 2,
                "nm": "Trim Paths 1",
                "mn": "ADBE Vector Filter - Trim",
                "hd": false
            }],
            "ip": 13,
            "op": 147,
            "st": 22,
            "bm": 0
        }, {
            "ddd": 0, "ind": 9, "ty": 2, "nm": "V_START", "refId": "image_0", "sr": 1, "ks": {
                "o": {"a": 1, "k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 56.139, "s": [100]}, {"t": 59.703125, "s": [0]}], "ix": 11},
                "r": {"a": 0, "k": -90, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.167, "y": 0.167}, "t": 12.475, "s": [563.985, -51.498, 0], "to": [0, 0, 0], "ti": [0, 0, 0]}, {
                        "i": {"x": 0.563, "y": 0.563},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 14.257,
                        "s": [563.985, -1.498, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"i": {"x": 0.66, "y": 0.66}, "o": {"x": 0.321, "y": 0.321}, "t": 27.631, "s": [563.985, 595.534, 0], "to": [0, 122.326, 0], "ti": [122.326, 0, 0]}, {
                        "i": {
                            "x": 0.674,
                            "y": 0.674
                        }, "o": {"x": 0.336, "y": 0.336}, "t": 35.426, "s": [342.493, 817.026, 0], "to": [-122.326, 0, 0], "ti": [0, 122.326, 0]
                    }, {"i": {"x": 0.696, "y": 0.696}, "o": {"x": 0.353, "y": 0.353}, "t": 43.222, "s": [121.002, 595.534, 0], "to": [0, -122.326, 0], "ti": [-122.326, 0, 0]}, {
                        "i": {
                            "x": 0.768,
                            "y": 0.768
                        }, "o": {"x": 0.402, "y": 0.402}, "t": 51.018, "s": [342.493, 374.043, 0], "to": [106.303, 0, 0], "ti": [-21.443, -99.897, 0]
                    }, {"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.4, "y": 0.4}, "t": 57.759, "s": [559.051, 548.827, 0], "to": [0, 0, 0], "ti": [0, -24.873, 0]}, {
                        "t": 58.8125,
                        "s": [563.985, 595.534, 0]
                    }],
                    "ix": 2
                },
                "a": {"a": 0, "k": [15.998, 3.896, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            }, "ao": 1, "ip": 5, "op": 139, "st": 14, "bm": 0
        }, {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "V",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [343.58, 408.762, 0], "ix": 2},
                "a": {"a": 0, "k": [267.994, 455.764, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [122.326, 0], [0, 122.326], [-122.326, 0], [-21.443, -99.897], [0, -24.873]],
                            "o": [[0, 0], [0, 122.326], [-122.326, 0], [0, -122.326], [106.303, 0], [0, 0], [0, 0]],
                            "v": [[221.491, -409.262], [221.491, 187.77], [-0.001, 409.262], [-221.492, 187.77], [-0.001, -33.721], [216.557, 141.063], [221.491, 187.77]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {"a": 0, "k": [0, 0.663000009574, 0.490000017952, 1], "ix": 3},
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 18.601, "ix": 5},
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [267.994, 455.764], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "tm",
                "s": {"a": 1, "k": [{"i": {"x": [0.394], "y": [1]}, "o": {"x": [0.214], "y": [0]}, "t": 24.95, "s": [0]}, {"t": 58.8125, "s": [30]}], "ix": 1},
                "e": {"a": 1, "k": [{"i": {"x": [0.833], "y": [0.833]}, "o": {"x": [0.167], "y": [0.167]}, "t": 14.257, "s": [0]}, {"t": 58.8125, "s": [100]}], "ix": 2},
                "o": {"a": 0, "k": 0, "ix": 3},
                "m": 1,
                "ix": 2,
                "nm": "Trim Paths 1",
                "mn": "ADBE Vector Filter - Trim",
                "hd": false
            }],
            "ip": 5,
            "op": 139,
            "st": 14,
            "bm": 0
        }, {
            "ddd": 0, "ind": 11, "ty": 2, "nm": "J_START", "refId": "image_0", "sr": 1, "ks": {
                "o": {"a": 1, "k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 43.664, "s": [100]}, {"t": 47.2275390625, "s": [0]}], "ix": 11},
                "r": {"a": 0, "k": -92, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.167, "y": 0.167}, "t": 0, "s": [530.002, -60.498, 0], "to": [0, 0, 0], "ti": [0, 0, 0]}, {
                        "i": {"x": 0.564, "y": 0.564},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 1.782,
                        "s": [530.002, -0.498, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"i": {"x": 0.663, "y": 0.663}, "o": {"x": 0.325, "y": 0.325}, "t": 16.783, "s": [530.002, 596.002, 0], "to": [0, 103.277, 0], "ti": [103.277, 0, 0]}, {
                        "i": {
                            "x": 0.676,
                            "y": 0.676
                        }, "o": {"x": 0.337, "y": 0.337}, "t": 24.172, "s": [343.002, 783.002, 0], "to": [-103.277, 0, 0], "ti": [0, 103.277, 0]
                    }, {"i": {"x": 0.696, "y": 0.696}, "o": {"x": 0.354, "y": 0.354}, "t": 31.56, "s": [156.002, 596.002, 0], "to": [0, -103.277, 0], "ti": [-103.277, 0, 0]}, {
                        "i": {
                            "x": 0.768,
                            "y": 0.768
                        }, "o": {"x": 0.402, "y": 0.402}, "t": 38.948, "s": [343.002, 409.002, 0], "to": [89.749, 0, 0], "ti": [-18.103, -84.34, 0]
                    }, {"i": {"x": 0.833, "y": 0.833}, "o": {"x": 0.4, "y": 0.4}, "t": 45.337, "s": [525.836, 556.568, 0], "to": [0, 0, 0], "ti": [0, -21, 0]}, {
                        "t": 46.3359375,
                        "s": [530.002, 596.002, 0]
                    }],
                    "ix": 2
                },
                "a": {"a": 0, "k": [15.998, 3.396, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            }, "ao": 1, "ip": 0, "op": 125, "st": 0, "bm": 0
        }, {
            "ddd": 0,
            "ind": 12,
            "ty": 4,
            "nm": "J",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [343.58, 391.25, 0], "ix": 2},
                "a": {"a": 0, "k": [233.502, 438.252, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [103.277, 0], [0, 103.277], [-103.277, 0], [-18.103, -84.34], [0, -21]],
                            "o": [[0, 0], [0, 103.277], [-103.277, 0], [0, -103.277], [89.749, 0], [0, 0], [0, 0]],
                            "v": [[187, -391.75], [187, 204.75], [0, 391.75], [-187, 204.75], [0, 17.75], [182.834, 165.316], [187, 204.75]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {"a": 0, "k": [1, 0.685999971278, 0.093999997307, 1], "ix": 3},
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 18.601, "ix": 5},
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [233.502, 438.252], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "tm",
                "s": {"a": 1, "k": [{"i": {"x": [0.257], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 26.733, "s": [0]}, {"t": 49.9013671875, "s": [34]}], "ix": 1},
                "e": {"a": 1, "k": [{"i": {"x": [0.833], "y": [0.833]}, "o": {"x": [0.167], "y": [0.167]}, "t": 1.782, "s": [0]}, {"t": 46.3359375, "s": [100]}], "ix": 2},
                "o": {"a": 0, "k": 0, "ix": 3},
                "m": 1,
                "ix": 2,
                "nm": "Trim Paths 1",
                "mn": "ADBE Vector Filter - Trim",
                "hd": false
            }],
            "ip": 0,
            "op": 125,
            "st": 0,
            "bm": 0
        }],
        "markers": []
    };
    var params        = {
        container: document.getElementById('lottie'),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: animationData
    };

    var anim;

    anim = lottie.loadAnimation(params);
});